import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

const Benefits = forwardRef((props, ref) => {
  return (
    <section id={props.id} ref={ref} className='home-section benefits'>
      <div className='container-fluid bg-color-ui-4'>
        <div className='container'>
          <div className='row py-3'>
            <div className='col-12'>
              <h3 title='descontos em muitas lojas, de muitos tipos.' tabIndex='0'>benefícios que vão te ajudar a vender mais.</h3>
              <ul className='flexible-items-container'>
                <li className='near-to-you flex-item' title='Imagem sobre comprar online, sem sair de casa.' tabIndex='0' />
                <li className='your-offers flex-item' title='Imagem sobre deixar seu dia mais gostoso.' tabIndex='0' />
                <li className='free flex-item' title='Imagem sobre presentear em toda ocasião.' tabIndex='0' />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
})

Benefits.propTypes = {
  id: PropTypes.string
}

export default Benefits



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/components/Benefits.js